export default "__VITE_ASSET__BrCpDA$6__"